import { EntityStateInfos } from '@wm-front/shared/interfaces'

/** Generates a clean initial state infos
 * along with the page infos returned by graphQL
 * @return { EntityStateInfos } entityStateInfos
 */
export function generateEntityStateInfos(loading = true): EntityStateInfos {
  const entityStateInfos: EntityStateInfos = {
    loading,
    error: null,
    totalCount: 0,
    pageInfos: {
      hasNextPage: false,
      hasPreviousPage: false,
      startCursor: '',
      endCursor: '',
    },
  }
  return entityStateInfos
}
